module.exports = __webpack_public_path__ + "static/img/komp.22687c5b.png";